<div class="accent-bar"></div>
<div class="accent-content">
  @if (title(); as title) {
    @if (title !== undefined) {
      <h3>{{ title }}</h3>
    }
  }
  <p>
    <ng-content></ng-content>
  </p>
</div>
